import * as React from 'react';
import { observer } from 'mobx-react';
import { FormField } from '../form-field';
import {MerchantCardPreference, WebGivingPaymentMethodModel} from '../../webgiving-generated';
import { PaymentMethod } from './payment-method';
import { AddPaymentMethod } from './add-payment-method';
import { isFunction } from '../../../Shared/utils/is-function';

export interface IPaymentMethodSelectorProps {
	field: FormField<string>;
	formControlId: string;
	paymentMethods:  WebGivingPaymentMethodModel[];
	merchantSupportsCard: boolean;
	cardPreference?: MerchantCardPreference | null;
	supportsAch: boolean;
	failedMethodId?: string;
	paymentMethodErrorElementId?: string;
	/**
	 * A callback to run when the user clicks on the add
	 * new payment method link within this component.
	 */
	onAddPaymentMethodClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
	/**
	 * The ARIA label text for the split button radio group.
	 * Required if ariaLabelledBy is not in use.
	 */
	ariaLabel?: string;
	/**
	 * The ARIA labelling element ID for the split button radio group.
	 * Required if ariaLabel is not in use.
	 */
	ariaLabelledBy?: string;
	onValueChange?: () => void;
}

@observer
export class PaymentMethodSelector extends React.Component<IPaymentMethodSelectorProps, {}> {

	render() {
		const {
			formControlId,
			paymentMethods,
			failedMethodId,
			merchantSupportsCard,
			cardPreference,
			supportsAch,
			ariaLabel,
			ariaLabelledBy,
			onAddPaymentMethodClick,
			paymentMethodErrorElementId,
			field: { value },
		} = this.props;

		return (
			<div
				className="row"
				role={(paymentMethods.length > 0) ? 'radiogroup' : undefined}
				aria-label={ariaLabel}
				aria-labelledby={ariaLabelledBy}
				data-pp-at-target="Payment Method Selector"
			>
				{paymentMethods.map((option, index) => {
					const checked = option.Id === value;
					const failed = option.Id === failedMethodId;

					return (
						<PaymentMethod
							key={option.Id}
							paymentMethod={option}
							checked={checked}
							ariaDescribedBy={failed ? paymentMethodErrorElementId : undefined}
							name={formControlId}
							onChange={this.onChange}
							id={`${formControlId}_${index}`}
							failed={failed}
						/>
					);
				})}
				<AddPaymentMethod
					onClick={onAddPaymentMethodClick}
					acceptanceTestTargetId={`${formControlId}_new-payment-method`}
					supportsCard={merchantSupportsCard}
					cardPreference={cardPreference}
					supportsAch={supportsAch}
				/>
			</div>
		);
	}

	onChange = (paymentMethod: WebGivingPaymentMethodModel) => {
		const { field, onValueChange } = this.props;

		field.updateValue(paymentMethod.Id);

		if(isFunction(onValueChange)) {
			onValueChange();
		}
	}
}
